import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Deletes a Speed Coaching Profile
 * @param speedCoachingProfileId The ID of the Speed Coaching Profile being deleted
 * @returns Data object indicating success
 */
export function deleteSpeedCoaching(
  this: unknown,
  speedCoachingProfileId: number
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetEnvironment.resolve(this).speedCoachingUrl
        }/${speedCoachingProfileId}`,
        {
          method: 'DELETE',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
        message: z.string(),
      })
    )
  );
}
